const local = window.location.href.includes('localhost')

export default {
  api: local ? 'http://localhost:8000/' : 'https://api.docuvaultapp.com/'
}
